export default __webpack_public_path__ + "static/media/failSend.d31d0899.png";